module.exports = __webpack_public_path__ + "img/flourandgraindust_icon.d24ee51f.svg";